import { render, staticRenderFns } from "./SettingsWorkflowView.vue?vue&type=template&id=5b548136&scoped=true&"
import script from "./SettingsWorkflowView.vue?vue&type=script&lang=js&"
export * from "./SettingsWorkflowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b548136",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VForm,VTab,VTabItem,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b548136')) {
      api.createRecord('5b548136', component.options)
    } else {
      api.reload('5b548136', component.options)
    }
    module.hot.accept("./SettingsWorkflowView.vue?vue&type=template&id=5b548136&scoped=true&", function () {
      api.rerender('5b548136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/workflow/SettingsWorkflowView.vue"
export default component.exports